"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URL = '/cosemail/v1/subscription-definitions';
var _default = {
  fetchActiveSubscriptions: function fetchActiveSubscriptions() {
    return _apiClient.default.get(BASE_URL + "/ensure-active-and-list", {
      timeout: 30000
    });
  }
};
exports.default = _default;
module.exports = exports.default;